import { render, staticRenderFns } from "./ChargingWorkspace.vue?vue&type=template&id=c0a09dca"
import script from "./ChargingWorkspace.vue?vue&type=script&lang=js"
export * from "./ChargingWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports